import { Route } from 'react-router-dom';
import { RouletteRoutes } from './RouletteRoutes';


export const GamesRoutes = (
  <Route path='games'>
    {RouletteRoutes}
  </Route>
);